import React from "react";

import { Grid, useTheme } from "@mui/material";

import { StyledAccordion } from "../Accordion";
import { ObjectTitle } from "../ObjectTitle";
import { componentSort } from "../utils";

import { CreatedKeyValueLine } from "./CreatedKeyValueLine";

export const CreatedObject = ({ to, k }: { to: any; k: string }) => {
  const theme = useTheme();
  if (Array.isArray(to) && !to.length) {
    return null;
  }

  return (
    <Grid
      container
      item
      direction={"row"}
      rowSpacing={1}
      className={"created-object"}
    >
      <StyledAccordion
        defaultExpanded={false}
        color={theme.igBorders.success.default}
        title={<ObjectTitle data={to} k={k} action={"Created"} />}
        content={
          <Grid container item direction={"column"} rowSpacing={1}>
            {to && typeof to === "object" ? (
              Object.keys(to).length ? (
                Object.entries(to)
                  .filter(([key, value]) => key !== "listKey")
                  .map(([k, value], index) => {
                    if (value && typeof value === "object") {
                      return {
                        type: "createdObject",
                        element: (
                          <CreatedObject
                            k={k}
                            to={value}
                            key={`${k}-${index}`}
                          />
                        ),
                      };
                    } else {
                      return {
                        type: "createdKeyValueLine",
                        element: (
                          <CreatedKeyValueLine
                            k={k}
                            value={value}
                            key={`${k}-${index}`}
                          />
                        ),
                      };
                    }
                  })
                  .sort(componentSort)
                  .map((i) => i.element)
              ) : (
                "Not Set"
              )
            ) : (
              <CreatedKeyValueLine k={k} value={to} key={k} />
            )}
          </Grid>
        }
      />
    </Grid>
  );
};
